import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Messaging } from './messaging';
import { IInjectedRootStore } from 'stores';

export function MessagingOutlet(props: IInjectedRootStore): React.ReactElement {
    return (
        <Routes>
            <Route path="" element={<Messaging {...props} />} />
            <Route path="compose" element={<Messaging {...props} />} />
            <Route path=":messageId" element={<Messaging {...props} />} />
        </Routes>
    );
}

